import { Component, OnInit } from '@angular/core';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AccountService } from '../../services/AccountService';
import { DealService } from '../../services/DealService';
import { AlertService } from '../../services/AlertService';
import { ConfirmationService } from 'primeng/api';
import { utility } from 'src/app/common/utility';

@Component({
  selector: 'app-deal-note',
  templateUrl: './deal-note.component.html',
  styleUrls: ['./deal-note.component.scss']
})
export class DealNoteComponent implements OnInit {

    //isAdmin: boolean = true;
    notes: any;
    dealId: any;
    addNoteDialogVisible: boolean = false;
    addNoteDialogMessage: string = '';
    noteToBeAdded: string = '';
    editNoteDialogVisible: boolean = false;
    editNoteDialogMessage: string = '';
    selectedNote: any;
    canEditDeleteDealNote: boolean = false;

    constructor(private breadcrumbService: AppBreadcrumbService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private accountService: AccountService,
        private dealService: DealService,
        private alertService: AlertService,
        private confirmationService: ConfirmationService,) { }

    ngOnInit(): void {
        this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
            this.notes = this.activatedRoute.snapshot.data['notes'];
            this.dealId = this.activatedRoute.snapshot.paramMap.get('id');
            this.selectedNote = { Note: '' };
            this.canEditDeleteDealNote = this.accountService.CanEditDeleteDealNote();

            this.breadcrumbService.setItems([
                this.breadcrumbService.deal,
                { label: this.dealId, routerLink: ['deal/' + this.dealId] },
                { label: 'Note', routerLink: [] }
            ]);
        });
    }

    removeHTML(str) {
        return utility.removeHTML(str);
    }

    showAddNoteDialog() {
        this.addNoteDialogMessage = '';
        this.noteToBeAdded = '';
        this.addNoteDialogVisible = true;
    }

    hideAddNoteDialog() {
        this.addNoteDialogVisible = false;
    }

    showEditNoteDialog(note) {
        this.editNoteDialogMessage = '';
        this.selectedNote = { ...note };
        this.editNoteDialogVisible = true;
    }

    hideEditNoteDialog() {
        this.editNoteDialogVisible = false;
    }

    addNote() {
        if (this.noteToBeAdded.trim().length == 0) {
            this.addNoteDialogMessage = 'A note is required';
        } else {
            this.addNoteDialogMessage = '';           
            this.dealService.AddDealNote(this.dealId, this.noteToBeAdded).subscribe(
                result => {
                    this.addNoteDialogVisible = false;
                    if (result.Id != null && result.Id != 0) {
                        this.alertService.SetMessage('success', 'Note is added');
                        var tempnotes = [...this.notes];
                        tempnotes.push(result);                        
                        this.notes = tempnotes;
                        this.notes.sort((a, b) => (a.Id > b.Id ? -1 : 1));
                    }
                    else {
                        this.alertService.SetMessage('error', 'There is an error while adding deal note');
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while adding deal note');
                }
            );
        }
    }

    deleteNote(note) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete this note?',
            accept: () => {
                this.dealService.DeleteDealNote(note.Id).subscribe(
                    result => {
                        if (result) {
                            this.notes = this.notes.filter(val => val.Id != note.Id);
                            this.alertService.SetMessage('success', 'Note is deleted');
                        }
                        else {
                            this.alertService.SetMessage('error', 'There is an error while deleting note');
                        }
                    },
                    error => {
                        this.alertService.SetMessage('error', 'There is an error while deleting note');
                    }
                );
            }
        });              
       
    }

    updateNote() {
        if (this.selectedNote.Note.trim().length == 0) {
            this.editNoteDialogMessage = 'A note is required';
        } else {
            this.editNoteDialogMessage = '';
            this.dealService.UpdateDealNote(this.selectedNote).subscribe(
                result => {
                    this.editNoteDialogVisible = false;
                    if (result.Id != null && result.Id != 0) {
                        var tempNotes = [...this.notes];
                        tempNotes[this.findIndexById(result.Id)] = result;
                        this.notes = [...tempNotes];
                        this.alertService.SetMessage('success', 'Note is added');                        
                    }
                    else {
                        this.alertService.SetMessage('error', 'There is an error while updating deal note');
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while updating deal note');
                }
            );
        }
    }

    
    findIndexById(id: string): number {
        let index = -1;
        for (let i = 0; i < this.notes.length; i++) {
            if (this.notes[i].Id === id) {
                index = i;
                break;
            }
        }

        return index;
    }    
}
